<template>
  <div>
    <div class="container">
      <div class="row py-5">
        <div class="col-12"><h1 class="pstitle">Compare Boats</h1></div>
      </div>
      <div class="table-responsive-sm">
        <table class="table table-bordered">
          <tr class="compare-table">
            <td>
              
            </td>
            <td v-for="boat in boats" :key="boat.id">
              <img
                v-if="boat.featuredImageURL"
                :src="boat.featuredImageURL"
                :alt="boat.brand"
              />
              <default-image v-else :id="boat.boatID" :model="boat.model" :alt-text="boat.brand" :width="175" />
            </td>
          </tr>
          <tr class="compare-table">
            <td>STATUS</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat.isUsed ? "Used" : "New Model" }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>LENGTH</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat.length }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>MAKE</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat.brand }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>MODEL</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ formatModel(boat.model) }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>YEAR</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat.modelYear }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>HULL #</td>
            <td v-for="boat in boats" :key="boat.id">
                <a :href="'/boat/details/' + boat.boatID">{{ boat?.hin ? boat.hin : "N/A" }}</a>
            </td>
          </tr>

          <tr class="compare-table">
            <td>ENGINE MODEL</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat?.engineModel ? boat.engineModel : "N/A" }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>ENGINE HOUR</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat?.engineHour ? boat.engineHour : "N/A" }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>BEAM</td>
            <td v-for="boat in boats" :key="boat.id">
              {{ boat?.beam ? boat.beam : "N/A" }}
            </td>
          </tr>

          <tr class="compare-table">
            <td>STARTING AT PRICE</td>
            <td v-for="boat in boats" :key="boat.id">
              <template v-if="boat.price>0">
                ${{ formatPrice(boat.price) }} USD
              </template>
              <template v-if="boat.price==null || boat.price==0">
                  Call for pricing
              </template>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import getEndPoint, { compareBoats } from "../../constants/api.config";
import DefaultImage from "../../components/atoms/DefaultImage.vue";
import StringUtils from "../../helpers/StringUtils";
export default {
  name: "CompareBoat",
  components:{
    DefaultImage
  },
  data() {
    return {
      boats: [],
    };
  },
  props: {
    ids: null,
  },
  methods: {
    getBoatsforCompare() {
      let urlParams = new URLSearchParams(window.location.search);
      this.axios
        .get(
          getEndPoint(compareBoats) +
            urlParams.get("ids").replace(/,/gi, "&BoatIds=")
        )
        .then((response) => {
          this.boats = response.data.data;
        })
        .catch((err) => console.log(err));
    },
    formatPrice(value) {
        return StringUtils.formatPrice(value);
    },
    formatModel(model) {
        return StringUtils.formatModel(model);
    }

  },
  mounted() {
    this.getBoatsforCompare();
  },
};
</script>
<style scoped>
.compare-table > td {
  border-right: 1px solid rgb(243, 243, 243);
  border-bottom: 1px solid rgb(243, 243, 243);
  padding: 0.8rem;
  min-width: 15rem;
}
.compare-table > td:first-child {
  border-left: 1px solid rgb(243, 243, 243);
}
.compare-table > td:last-child {
  padding-bottom: 0;
  padding-right: 0 !important;
}
img {
  max-width: 100%;
  max-height: 150px;
  display: block; /* remove extra space below image */
}
@media screen and (max-width: 767px) {
  .table-responsive-sm{
    width: 98vw;
    overflow-x:auto;
    display: block;
}
}
</style>

